import { createFileRoute, Outlet } from "@tanstack/react-router";
import { LegalLayout } from "@/components/legal/legal-layout";
import { MarketingLayout } from "@/features/marketing/marketing-layout";

/** /legal/* — public, readable signed out (the sign-up form links here); the public site's header and footer around it. */
export const Route = createFileRoute("/legal")({
  component: () => (
    <MarketingLayout>
      <LegalLayout>
        <Outlet />
      </LegalLayout>
    </MarketingLayout>
  ),
});
